import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertEvent } from '../../models/alert-event';
import { AlertsHandlerService } from '../../services/alerts-handler.service';
import { debounceTime } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

const TIME = {
  seconds: 5,
};

@Component({
  selector: 'app-alerts-handler',
  templateUrl: './alerts-handler.component.html',
  styleUrls: ['./alerts-handler.component.scss'],
  imports: [CommonModule, NgbAlertModule],
})
export class AlertsHandlerComponent implements OnInit {

  private status: Observable<AlertEvent>;
  public type: string;
  public message: string;
  public showAlert: boolean;

  constructor(private alertsHandlerService: AlertsHandlerService) { }

  public ngOnInit(): void {
    this.showAlert = false;
    this.status = this.alertsHandlerService.getErrorAlertStatus();
    this.status.subscribe((event: AlertEvent) => {
      this.type = event.type;
      this.message = event.message;
      this.showAlert = true;
    });
    this.status.pipe(debounceTime(1000 * TIME.seconds)).subscribe(() => this.showAlert = false);
  }

  public close(): void {
    this.showAlert = false;
  }
}
